// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ArchivesController from "./archives_controller"
application.register("archives", ArchivesController)

import PaperController from "./paper_controller"
application.register("paper", PaperController)

import UserFiltersController from "./user_filters_controller"
application.register("user-filters", UserFiltersController)

import NavbarController from "./navbar_controller"
application.register("navbar", NavbarController)

import HomeController from "./home_controller"
application.register("home", HomeController)

import UsersController from "./users_controller"
application.register("users", UsersController)

import NotificationsController from "./notifications_controller"
application.register("notifications", NotificationsController)

import EditDescriptionController from "./edit_description_controller"
application.register("edit-description", EditDescriptionController)

import FlatpickrController from "./flatpickr_controller"
application.register("flatpickr", FlatpickrController)

import TomSelectController from "./tom_select_controller"
application.register("tom-select", TomSelectController)

import BoardMembersController from "./board_members_controller"
application.register("board-members", BoardMembersController)
